<template>
    <template v-if="item.data && item.data.length > 1">
        <div class="overview-card overview-card--multiple">
            <div v-for="(card, index) in item.data" :key="index" class="overview-card__container">
                <div class="overview-card__img">
                    <img v-if="!card.icon" src="@/assets/images/placeholder-icon.png" :alt="card.name" />
                    <img v-else :src="`${apiUri}${card.icon}`" :alt="card.name" />
                </div>

                <div class="overview-card__info">
                    <p v-if="index == 0" class="overview-card__label">{{ item.key }}</p>
                    <h3 class="overview-card__title">{{ card.name }}</h3>
                    <p class="overview-card__text" v-html="formatValueWithUnit(calculateFullPrice(card.name, card.price.value, card.price.unit, item.key), card.price.unit)"></p>
                    <router-link :to="{name: 'game-menu', params: {phaseId: item.id, phaseKey: item.key, phaseMultichoice: item.multipleChoices, editing: true}}" class="btn btn--edit">
                        <span>{{ $t('button.change') }}</span>
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.25 9.17501L20.825 5.75001C20.378 5.33013 19.7922 5.0892 19.1792 5.07307C18.5661 5.05694 17.9685 5.26672 17.5 5.66251L6.25 16.9125C5.84596 17.32 5.59439 17.854 5.5375 18.425L5 23.6375C4.98317 23.8206 5.00692 24.0051 5.06958 24.178C5.13224 24.3508 5.23226 24.5077 5.3625 24.6375C5.4793 24.7534 5.61782 24.845 5.77012 24.9072C5.92242 24.9694 6.0855 25.001 6.25 25H6.3625L11.575 24.525C12.146 24.4681 12.68 24.2165 13.0875 23.8125L24.3375 12.5625C24.7742 12.1012 25.0101 11.4856 24.9937 10.8507C24.9773 10.2157 24.7099 9.61314 24.25 9.17501ZM20 13.35L16.65 10L19.0875 7.50001L22.5 10.9125L20 13.35Z" fill="#F88C50"/>
                        </svg>
                    </router-link>
                </div>
            </div>
        </div>
    </template>
    <template v-else-if="item.data && item.data.length">
        <div v-for="(card, index) in item.data" :key="index" class="overview-card">
            <div class="overview-card__img">
                <img v-if="!card.icon" src="@/assets/images/placeholder-icon.png" :alt="card.name" />
                <img v-else :src="`${apiUri}${card.icon}`" :alt="card.name" />
            </div>

            <div class="overview-card__info">
                <p class="overview-card__label">{{ item.key }}</p>
                <h3 class="overview-card__title">{{ card.name }}</h3>
                <p class="overview-card__text" v-html="formatValueWithUnit(calculateFullPrice(card.name, card.price.value, card.price.unit, item.key), card.price.unit)"></p>
                <router-link :to="{name: 'game-menu', params: {phaseId: item.id, phaseKey: item.key, phaseMultichoice: item.multipleChoices, editing: true}}" class="btn btn--edit">
                    <span>{{ $t('button.change') }}</span>
                    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M24.25 9.17501L20.825 5.75001C20.378 5.33013 19.7922 5.0892 19.1792 5.07307C18.5661 5.05694 17.9685 5.26672 17.5 5.66251L6.25 16.9125C5.84596 17.32 5.59439 17.854 5.5375 18.425L5 23.6375C4.98317 23.8206 5.00692 24.0051 5.06958 24.178C5.13224 24.3508 5.23226 24.5077 5.3625 24.6375C5.4793 24.7534 5.61782 24.845 5.77012 24.9072C5.92242 24.9694 6.0855 25.001 6.25 25H6.3625L11.575 24.525C12.146 24.4681 12.68 24.2165 13.0875 23.8125L24.3375 12.5625C24.7742 12.1012 25.0101 11.4856 24.9937 10.8507C24.9773 10.2157 24.7099 9.61314 24.25 9.17501ZM20 13.35L16.65 10L19.0875 7.50001L22.5 10.9125L20 13.35Z" fill="#F88C50"/>
                    </svg>
                </router-link>
            </div>
        </div>
    </template>
    <template v-else-if="!item.data.length && item.disabledByMaterial && showCardWithNoData">
        <div :class="['overview-card overview-card--empty', {'highlight': !overviewTooltips.includes(item.id)}]">
            <div class="overview-card__img">
                <img src="@/assets/images/placeholder-icon.png" :alt="item.key" />
            </div>

            <div class="overview-card__info">
                <p class="overview-card__label">{{ item.key }}</p>
                <h3 class="overview-card__title">{{ $t('game.overview.card-title') }}</h3>
                <p class="overview-card__desc">{{ $t('game.overview.card-text') }}</p>
                <router-link :to="{name: 'game-menu', params: {phaseId: item.id, phaseKey: item.key, phaseMultichoice: item.multipleChoices, editing: true}}" class="btn btn--edit">
                    <span>{{ $t('button.select') }}</span>
                    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M24.25 9.17501L20.825 5.75001C20.378 5.33013 19.7922 5.0892 19.1792 5.07307C18.5661 5.05694 17.9685 5.26672 17.5 5.66251L6.25 16.9125C5.84596 17.32 5.59439 17.854 5.5375 18.425L5 23.6375C4.98317 23.8206 5.00692 24.0051 5.06958 24.178C5.13224 24.3508 5.23226 24.5077 5.3625 24.6375C5.4793 24.7534 5.61782 24.845 5.77012 24.9072C5.92242 24.9694 6.0855 25.001 6.25 25H6.3625L11.575 24.525C12.146 24.4681 12.68 24.2165 13.0875 23.8125L24.3375 12.5625C24.7742 12.1012 25.0101 11.4856 24.9937 10.8507C24.9773 10.2157 24.7099 9.61314 24.25 9.17501ZM20 13.35L16.65 10L19.0875 7.50001L22.5 10.9125L20 13.35Z" fill="#F88C50"/>
                    </svg>
                </router-link>
            </div>

            <div v-if="!overviewTooltips.includes(item.id) && $route.name != 'budget'" class="tooltip tooltip--top scroll-reveal animate__animated" data-animation="bounceInUp">
                <div class="tooltip__title">{{ $t('game.tooltip.phase-disabled.title') }}</div>
                <div class="tooltip__text">{{ $t('game.tooltip.choose-material') }} {{ item.key }}</div>
                <button @click="closeCardTooltip" class="btn btn--small btn--persimmon">{{ $t('button.i-understand') }}</button>
            </div>
        </div>
    </template>
    <template v-else>
        <div v-if="item.icon" class="overview-card">
            <div class="overview-card__img">
                <img v-if="!item.icon" src="@/assets/images/placeholder-icon.png" :alt="item.key" />
                <img v-else :src="`${apiUri}${item.icon}`" :alt="item.key" />
            </div>

            <div class="overview-card__info">
                <p class="overview-card__label">{{ item.key }}</p>
                <h3 v-if="item.data.unit" class="overview-card__title" v-html="formatValueWithUnit(item.data.value, item.data.unit)"></h3>
                <h3 v-else class="overview-card__title">{{ item.data.value }}</h3>
                <button @click="editOption(index)" class="btn btn--edit">
                    <span>{{ $t('button.change') }}</span>
                    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M24.25 9.17501L20.825 5.75001C20.378 5.33013 19.7922 5.0892 19.1792 5.07307C18.5661 5.05694 17.9685 5.26672 17.5 5.66251L6.25 16.9125C5.84596 17.32 5.59439 17.854 5.5375 18.425L5 23.6375C4.98317 23.8206 5.00692 24.0051 5.06958 24.178C5.13224 24.3508 5.23226 24.5077 5.3625 24.6375C5.4793 24.7534 5.61782 24.845 5.77012 24.9072C5.92242 24.9694 6.0855 25.001 6.25 25H6.3625L11.575 24.525C12.146 24.4681 12.68 24.2165 13.0875 23.8125L24.3375 12.5625C24.7742 12.1012 25.0101 11.4856 24.9937 10.8507C24.9773 10.2157 24.7099 9.61314 24.25 9.17501ZM20 13.35L16.65 10L19.0875 7.50001L22.5 10.9125L20 13.35Z" fill="#F88C50"/>
                    </svg>
                </button>
            </div>
        </div>
    </template>
</template>

<script>
export default {
    name: 'OverviewCard',
    props: ['item', 'index'],
    inject: ['formatValueWithUnit', 'calculateFullPrice', 'scrollTrigger', 'addObserver'],
    computed: {
        apiUri() {
            return process.env.VUE_APP_APOLLO_API_URI;
        },
        savedMaterials() {
            return this.$store.getters['game/getSavedMaterials'];
        },
        showCardWithNoData() {
            let showCard = true;
            
            this.savedMaterials.forEach(phase => {
                if (phase.data) {
                    phase.data.forEach(material => {
                        if (this.item.disabledByMaterial) {
                            this.item.disabledByMaterial.forEach(mat => {
                                if (material.uniqueId == mat.id) {
                                    showCard = false;
                                }
                            });
                        }
                    });
                }
            });

            if (showCard && !this.overviewTooltips.includes(this.item.id) && this.$route.name != 'budget') {
                document.body.classList.add('overlay');
            }

            if (this.$route.name == 'budget') {
                showCard = false;
            }

            return showCard;
        },
        overviewTooltips() {
            return this.$store.getters['game/getTooltipsOverview'];
        }
    },
    methods: {
        editOption(index) {
            let step = index + 1;
            this.$store.commit('game/updateStep', step);
            this.$store.commit('game/updatingOption', true);
        },
        closeCardTooltip() {
            this.$store.commit('game/updateOverviewTooltips', this.item.id);
            document.body.classList.remove('overlay');
        }
    },
    mounted() {
        this.scrollTrigger('.scroll-reveal', {
            rootMargin: '-50px'
        });
    }
}
</script>
